(() => {
  if (window.GrindZealotStorefront) return;

  const storageKey = "grind-zealot-wishlist-v1";

  const readWishlist = () => {
    try {
      const value = JSON.parse(localStorage.getItem(storageKey) || "[]");
      return Array.isArray(value) ? value : [];
    } catch {
      return [];
    }
  };

  const writeWishlist = (items) => {
    try {
      localStorage.setItem(storageKey, JSON.stringify(items));
    } catch (error) {
      console.warn("Wishlist could not be saved on this device.", error);
    }
  };

  const readCurrentProduct = () => {
    const data = document.querySelector("[data-gz-current-product]");
    if (!data) return null;
    try {
      return JSON.parse(data.textContent);
    } catch (error) {
      console.error("Current product data could not be read.", error);
      return null;
    }
  };

  const updateWishlistCount = (items) => {
    document.querySelectorAll("[data-gz-wishlist-count]").forEach((count) => {
      count.textContent = String(items.length);
      count.hidden = items.length === 0;
    });
  };

  const updateProductWishlistButton = (items, product) => {
    if (!product) return;
    const saved = items.some((item) => String(item.id) === String(product.id));
    document.querySelectorAll("[data-gz-product-wishlist]").forEach((button) => {
      button.setAttribute("aria-pressed", String(saved));
      button.textContent = saved ? "Saved to wishlist" : "Save to wishlist";
    });
  };

  const createWishlistItem = (item, onRemove) => {
    const listItem = document.createElement("li");
    listItem.className = "gz-wishlist-item";

    if (item.image) {
      const imageLink = document.createElement("a");
      imageLink.href = item.url;
      const image = document.createElement("img");
      image.src = item.image;
      image.alt = item.title || "Saved product";
      image.loading = "lazy";
      image.width = 72;
      image.height = 72;
      imageLink.append(image);
      listItem.append(imageLink);
    } else {
      listItem.append(document.createElement("span"));
    }

    const copy = document.createElement("div");
    const title = document.createElement("a");
    title.className = "gz-wishlist-item__title";
    title.href = item.url;
    title.textContent = item.title || "Saved product";
    copy.append(title);
    if (item.price) {
      const price = document.createElement("span");
      price.textContent = item.price;
      copy.append(price);
    }
    listItem.append(copy);

    const remove = document.createElement("button");
    remove.type = "button";
    remove.className = "gz-wishlist-item__remove";
    remove.textContent = "Remove";
    remove.addEventListener("click", onRemove);
    listItem.append(remove);
    return listItem;
  };

  const renderWishlist = (items, product) => {
    const list = document.querySelector("[data-gz-wishlist-list]");
    const empty = document.querySelector("[data-gz-wishlist-empty]");
    updateWishlistCount(items);
    updateProductWishlistButton(items, product);
    if (!list) return;

    list.replaceChildren(
      ...items.map((item) =>
        createWishlistItem(item, () => {
          const next = readWishlist().filter(
            (saved) => String(saved.id) !== String(item.id),
          );
          writeWishlist(next);
          renderWishlist(next, product);
        }),
      ),
    );
    if (empty) empty.hidden = items.length > 0;
  };

  const openDialog = (dialog) => {
    if (!dialog) return;
    if (typeof dialog.showModal === "function") dialog.showModal();
    else dialog.setAttribute("open", "");
  };

  const initWishlist = (product) => {
    const trigger = document.querySelector("[data-gz-wishlist-open]");
    const headerIcons = document.querySelector(".header__icons");
    if (trigger) {
      trigger.hidden = false;
      if (headerIcons) {
        trigger.classList.remove("gz-wishlist-trigger--fallback");
        trigger.classList.add("header__icon", "link", "focus-inset");
        const cartIcon = headerIcons.querySelector("header-drawer, .header__icon--cart");
        headerIcons.insertBefore(trigger, cartIcon || null);
      }
      trigger.addEventListener("click", () =>
        openDialog(document.getElementById("GzWishlistDialog")),
      );
    }

    document.querySelector("[data-gz-wishlist-close]")?.addEventListener("click", () => {
      document.getElementById("GzWishlistDialog")?.close();
    });

    const dialog = document.getElementById("GzWishlistDialog");
    dialog?.addEventListener("click", (event) => {
      if (event.target === dialog) dialog.close();
    });

    const template = document.querySelector("[data-gz-product-wishlist-template]");
    const productInfo = document.querySelector('product-info[id^="MainProduct-"]');
    const nativeProductForm = productInfo?.querySelector("product-form");
    if (product && template && nativeProductForm && !document.querySelector("[data-gz-product-wishlist]")) {
      const button = template.content.firstElementChild.cloneNode(true);
      nativeProductForm.after(button);
      button.addEventListener("click", () => {
        const items = readWishlist();
        const index = items.findIndex((item) => String(item.id) === String(product.id));
        if (index >= 0) items.splice(index, 1);
        else items.unshift(product);
        writeWishlist(items);
        renderWishlist(items, product);
      });
    }

    renderWishlist(readWishlist(), product);
  };

  const initConfidencePanel = () => {
    const productInfo = document.querySelector('product-info[id^="MainProduct-"]');
    const nativeProductForm = productInfo?.querySelector("product-form");
    const template = document.querySelector("[data-gz-confidence-template]");
    if (!nativeProductForm || !template || document.querySelector(".gz-confidence")) return;
    nativeProductForm.parentElement?.append(template.content.firstElementChild.cloneNode(true));
  };

  const selectedVariantLabel = (productInfo) => {
    const checked = [...productInfo.querySelectorAll("fieldset input[type='radio']:checked")]
      .map((input) => input.value?.trim())
      .filter(Boolean);
    if (checked.length) return checked.join(" / ");

    return [...productInfo.querySelectorAll("variant-selects select")]
      .map((select) => select.selectedOptions[0]?.textContent?.trim())
      .filter(Boolean)
      .join(" / ");
  };

  const initStickyCart = () => {
    const sticky = document.querySelector("[data-gz-sticky-cart]");
    const productInfo = document.querySelector('product-info[id^="MainProduct-"]');
    const form = productInfo?.querySelector("product-form form");
    const submit = form?.querySelector("[type='submit']");
    const stickySubmit = sticky?.querySelector("[data-gz-sticky-submit]");
    if (!sticky || !productInfo || !form || !submit || !stickySubmit) return;

    const update = () => {
      const price = productInfo.querySelector(
        ".price__sale .price-item--sale, .price-item--regular",
      );
      const stickyPrice = sticky.querySelector("[data-gz-sticky-price]");
      const stickyVariant = sticky.querySelector("[data-gz-sticky-variant]");
      if (stickyPrice && price?.textContent) stickyPrice.textContent = price.textContent.trim();
      if (stickyVariant) stickyVariant.textContent = selectedVariantLabel(productInfo);
      stickySubmit.disabled = submit.disabled;
      stickySubmit.textContent = submit.disabled
        ? window.variantStrings?.soldOut || "Sold out"
        : window.variantStrings?.addToCart || "Add to cart";
    };

    const setVisible = (visible) => {
      sticky.classList.toggle("is-visible", visible);
      sticky.setAttribute("aria-hidden", String(!visible));
      document.body.classList.toggle("gz-sticky-cart-visible", visible);
    };

    const updateVisibility = () => {
      const submitBounds = submit.getBoundingClientRect();
      const submitIsVisible =
        submitBounds.bottom > 0 && submitBounds.top < window.innerHeight;
      setVisible(!submitIsVisible && window.scrollY > 400);
    };

    stickySubmit.addEventListener("click", () => {
      update();
      if (!submit.disabled) form.requestSubmit(submit);
    });

    productInfo.addEventListener("change", () => window.setTimeout(update, 0));
    const mutationObserver = new MutationObserver(update);
    mutationObserver.observe(productInfo, {
      subtree: true,
      childList: true,
      characterData: true,
      attributes: true,
      attributeFilter: ["disabled"],
    });

    const intersectionObserver = new IntersectionObserver(
      updateVisibility,
      { threshold: 0.1 },
    );
    intersectionObserver.observe(submit);
    window.addEventListener("scroll", updateVisibility, { passive: true });
    window.addEventListener("resize", updateVisibility);
    update();
    updateVisibility();
  };

  const initScrollTop = () => {
    const button = document.querySelector("[data-gz-scroll-top]");
    if (!button) return;
    const update = () => button.classList.toggle("is-visible", window.scrollY > 700);
    window.addEventListener("scroll", update, { passive: true });
    button.addEventListener("click", () => {
      window.scrollTo({
        top: 0,
        behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches
          ? "auto"
          : "smooth",
      });
    });
    update();
  };

  const init = () => {
    const product = readCurrentProduct();
    initWishlist(product);
    initConfidencePanel();
    initStickyCart();
    initScrollTop();
  };

  window.GrindZealotStorefront = { init };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }
})();
